import { useLocalSearchParams } from 'expo-router'

import { FraternityRecapScreen } from '@/src/features/fraternity/ui/screens/FraternityRecapScreen'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

const CommunityJoinRecapRouterPage = () => {
  const searchParams = useLocalSearchParams()
  const { idSlug } = filterSearchParams<TIdSlugParam>(searchParams)

  if (!idSlug) return null

  return <FraternityRecapScreen idSlug={idSlug} searchParams={searchParams} />
}

export default CommunityJoinRecapRouterPage
